const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const reducerWatermart = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SAGA_UPDATE_WATERMARK_REQUEST":
      return { loading: true, error: false };
    case "SAGA_UPDATE_WATERMARK_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "SAGA_UPDATE_WATERMARK_ERROR":
      return { loading: false, error: true, data: action.payload };
    default:
      return state;
  }
};

export default reducerWatermart;
